<template>
  <div>
    <details-modal
      :show="show"
      :current-operation="currentOperation"
      @close="closeModal"
      @cancel="closeModal"
      @create="departmentButtonClicked"
      @delete="deleteDepartmentButtonClicked"
      @update="updateDepartmentButtonClicked"
    >
      <form class="text-left">
        <div class="row">
          <fg-input
            v-validate="'required'"
            v-model="department.name"
            class="col-md-12"
            data-vv-scope="formDepartmentDetails"
            name="nom"
            required
            type="text"
            label="Nom"
          />
          <div v-if="errors.items.length" class="validation-error">
            {{ errors.first('formDepartmentDetails.nom') }}
          </div>
        </div>
      </form>
      <p v-if="errorMessage" class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import DetailsModal from './DetailsModal.vue';

export default {
  components: {
    DetailsModal,
  },
  props: {
    show: Boolean,
    currentOperation: String,
    department: Object,
    institutionId: Number,
  },
  data() {
    return {
      errorMessage: '',
    };
  },
  methods: {
    departmentButtonClicked() {
      // Validate that the required field are filled before creating record
      this.$validator.validateAll('formDepartmentDetails').then(result => {
        if (result) {
          this.errorMessage = null;

          this.$http
            .post(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/institutions/${this.institutionId}/departments`,
              {
                name: this.department.name,
              },
            )
            .then(response => {
              this.closeModal();
            })
            .catch(error => {
              this.errorMessage =
                'Une erreur est survenue lors de la création du département, veuillez réessayer ou contacter le support.';
            });
        } else {
          this.errorMessage = 'Veuillez corriger les erreurs.';
        }
      });
    },
    updateDepartmentButtonClicked() {
      // Validate that the required field are filled before creating record
      this.$validator.validateAll('formDepartmentDetails').then(result => {
        if (result) {
          this.errorMessage = null;

          this.$http
            .patch(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/institutions/${this.institutionId}/departments/${this.department.id}`,
              {
                name: this.department.name,
              },
            )
            .then(response => {
              this.closeModal();
            })
            .catch(error => {
              this.errorMessage =
                "Une erreur est survenue lors de l'édition du département, veuillez réessayer ou contacter le support.";
            });
        } else {
          this.errorMessage = 'Veuillez corriger les erreurs.';
        }
      });
    },
    deleteDepartmentButtonClicked() {
      this.errorMessage = null;

      swal({
        title: 'Êtes-vous sûr de vouloir supprimer ce département ?',
        text: "Il ne sera pas possible d'annuler cette suppression",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      })
        .then(() => {
          this.$http
            .delete(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/institutions/${this.institutionId}/departments/${this.department.id}`,
            )
            .then(response => {
              this.closeModal();
            })
            .catch(error => {
              this.errorMessage =
                'Une erreur est survenue lors de la suppression du département, veuillez réessayer ou contacter le support.';
            });
        })
        .catch(() => {});
    },
    closeModal() {
      this.$emit('close');
      this.errorMessage = '';
      this.name = null;
    },
  },
};
</script>

<style scoped>
.validation-error {
  color: red;
  margin-bottom: 1em;
}
</style>
